
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/indexed-product",
      function () {
        return require("private-next-pages/indexed-product.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/indexed-product"])
      });
    }
  